export default "__VITE_ASSET__BaVuoBVi__"